import { render, staticRenderFns } from "./serviceSingleLabel.vue?vue&type=template&id=2ec67a3c&scoped=true"
import script from "./serviceSingleLabel.vue?vue&type=script&lang=js"
export * from "./serviceSingleLabel.vue?vue&type=script&lang=js"
import style0 from "./serviceSingleLabel.vue?vue&type=style&index=0&id=2ec67a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec67a3c",
  null
  
)

export default component.exports